export default __webpack_public_path__ + "static/media/TheSummitEscape.c9ea1099.jpg";